import { render } from "./CategorySegmentServicesTabView.vue?vue&type=template&id=74a42108"
import script from "./CategorySegmentServicesTabView.vue?vue&type=script&lang=js"
export * from "./CategorySegmentServicesTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__